import {ChangeDetectionStrategy, Component, Inject} from '@angular/core';
import {UntypedFormControl} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'app-selector-dialog',
    templateUrl: './selector-dialog.component.html',
    styleUrls: ['./selector-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SelectorDialogComponent {
    option = new UntypedFormControl();

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            label: string,
            options: string[]
            optionsTranslation: string
            button: string
        },
        public dialogRef: MatDialogRef<SelectorDialogComponent>,
    ) {
    }

    /** Close dialog */
    closeDialog(result: boolean, data?: any) {
        this.dialogRef.close({result, data});
    }
}
